export const mainQuemSomos = [

    {
      id: 0,
      reverse:"reverse",
      imagem: "https://somosconexaosocial.org/site_img/main_home/01.jpg",
      titulo: 'Quem Somos?',
      slideProjeto: 'A Associação Conexão Social (ACS) é uma organização da sociedade civil sem fins lucrativos que foi fundada em maio de 2005 no município de Lagoa de Itaenga, na zona da Mata Norte de Pernambuco. A organização possui o objetivo principal de mobilizar a população em busca da garantia dos direitos das pessoas em situação de vulnerabilidade social. Acreditando que a educação é uma poderosa ferramenta para a transformação social, a ACS atende em seus projetos, crianças, adolescentes, jovens, mulheres e idosos.'

        
    },
    {
      id: 1,
      reverse:"",
      imagem: "https://somosconexaosocial.org/site_img/main_home/02.jpg",
      titulo: 'Missão',
      slideProjeto: 'Impulsionamos a inclusão social por meio da conexão com projetos inovadores de educação transformadora.'

        
    },
    {
      id: 2,
      reverse:"reverse",
      imagem: "https://somosconexaosocial.org/site_img/main_home/03.jpg",
      titulo: 'Visão',
      slideProjeto: 'Em 2030, a Conexão Social é referência no Brasil pelo seu trabalho de inclusão social e seu compromisso com a promoção de práticas sustentáveis e soluções inovadoras'

        
    },

    {
      id: 2,
      reverse:"",
      imagem: "https://somosconexaosocial.org/site_img/main_home/04.jpg",
      titulo: 'Valores',
      slideProjeto: 'Acolhimentoe Qualidade nos Serviços; Aprendizadoe Desenvolvimento; Compromissoe Resiliência; Conexão Social e Trabalho em Rede; Empatia e Cuidado; Ética e Transparência; Inclusão e Participação; Inovaçãoe Adaptabilidade; Respeitoe Diversidade; Responsabilidade Social e Ambiental; Senso de Justiça e Colaboração; Solidariedade e Comunidade.'

        
    },

      




];
